/* eslint no-console:0 */

import "../stylesheets/application.sass"

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "trix"
import "@rails/actiontext"

window.Sockets = {} // used to hold on to socket connections
if (!window._rails_loaded) {
  Rails.start() // had a double load issue on servers
}
ActiveStorage.start()

// Setup enhanced error logging for file uploads
import { setupActiveStorageErrorLogging } from "../utils/activestorage_error_logger"
setupActiveStorageErrorLogging()

document.addEventListener("turbo:frame-load", () => {
  try {
    if (window.ActiveStorage) ActiveStorage.start();
  } catch (error) {
    console.warn("Failed to start ActiveStorage on turbo:frame-load", error);
  }
});
document.addEventListener("turbo:load", () => {
  try {
    if (window.ActiveStorage) ActiveStorage.start();
  } catch (error) {
    console.warn("Failed to start ActiveStorage on turbo:load", error);
  }
});

import "../../assets/javascripts/lib/element_in_viewport"
import "../../assets/javascripts/lib/replace_element_with_partial"

import "../src/pages"
import "../src/comment_file_upload_fix"
import "../src/site_theme"

import "../controllers"

// run code on turbo:load load event
document.addEventListener("turbo:load", function() {
  // console.log('hi from turbo:load in application.js', )
})
